import { render, staticRenderFns } from "./ProgramTemplate.vue?vue&type=template&id=46a6298d&scoped=true"
import script from "./ProgramTemplate.vue?vue&type=script&lang=js"
export * from "./ProgramTemplate.vue?vue&type=script&lang=js"
import style0 from "./ProgramTemplate.vue?vue&type=style&index=0&id=46a6298d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a6298d",
  null
  
)

export default component.exports